export const center = {
  lat: 40.4165001,
  lng: -3.7025599
}

export const collectionName = 'test-places';

